// @ts-ignore
import OmegaTracker from '@didi/omega-tracker';

// eslint-disable-next-line
import { useCommonStore } from '@/store/common';
import { queryURLParams } from './utils';

const config = {
  appKey: 'omegaa7a4f5c8b9',
  uploadHost: 'omgup.didiglobal.com',
  autoClick: false, // 全局点击事件监控，如不需要 建议关闭
  attrs: {
    version: `${process.env.APP_NAME}@${process.env.APP_VERSION}`
  }
};
const Omega = OmegaTracker.getTracker(config);

const getBasicAttrs = () => {
  return {};
};

const trackEvent = (eventId: string, attrs = {}) => {
  const basicAttrs = getBasicAttrs() || {};

  try {
    Omega && Omega.trackEvent(eventId, '', { ...basicAttrs, ...attrs });
  } catch (err) {
    console.log('omega upload error');
  }
};

const traceApiError = (
  base: string,
  {
    path = '',
    params = '',
    status = 0,
    code = 0,
    msg = '',
    trace_id = '',
    ...others
  }: {
    path: string;
    params: string | object;
    status: number | string;
    code: number | string;
    msg: string;
    trace_id: string;
  }
) => {
  const commonStore = useCommonStore();
  const query = queryURLParams(window.location.href);

  trackEvent('tech_fleetmatching_api_error', {
    base: base || path || '',
    path,
    params,
    status,
    code,
    msg,
    trace_id,
    user_id: commonStore?.roleInfo?.user_id || '', // 用户、系统信息收敛至接口内
    username: '',
    os_type: /(?:Android)/.test(navigator?.userAgent) ? 'Android' : 'IOS',
    os_version: '',
    env: import.meta.env.MODE,
    app_version: query?.appversion || '',
    ...others
  });
};

const traceBusinessError = (
  business: string, // 业务场景
  type: string, // 类型
  {
    params = '',
    status = 0,
    msg = '',
    ...others
  }: {
    params?: string | object;
    status?: number | string;
    msg?: string;
  }
) => {
  const commonStore = useCommonStore();
  const query = queryURLParams(window.location.href);

  trackEvent('tech_fleetmatching_business_error', {
    business,
    type,
    params,
    status,
    msg,
    user_id: commonStore?.roleInfo?.user_id || '', // 用户、系统信息收敛至接口内
    username: '',
    os_type: /(?:Android)/.test(navigator?.userAgent) ? 'Android' : 'IOS',
    os_version: '',
    env: import.meta.env.MODE,
    app_version: query?.appversion || '',
    ...others
  });
};

export default {
  Omega,
  getBasicAttrs,
  trackEvent,
  traceApiError,
  traceBusinessError
};
